module.exports = __webpack_public_path__ + "images/emoji/syringe.948758c14dbacf030da3.png";